import styled from "styled-components";

// Make the screen reader say whatever is in this element, but is hidden from plain view.
// Citation: https://zellwk.com/blog/hide-content-accessibly/
export const HiddenAccessibleSpan = styled.span`
  position: absolute !important;
  opacity: 0;
  pointer-events: none;
`;
